import { useAuth } from "react-oidc-context";
import { motion } from "framer-motion";
import Typography from "core/components/Typography";
import Button from "core/components/Button";

const UserProfileChangePasswordPage = () => {
  const auth = useAuth();

  return (
    <motion.div style={{ marginBottom: "30vh" }}>
      <Typography variant="h2">Password</Typography>
      <div style={{ maxWidth: "600px" }}>
        <Typography
          variant="p"
          noMargin
          style={{ lineHeight: "22px", marginBottom: "24px" }}
        >
          Clicking the button below will redirect you to a page where you can
          update your password.
        </Typography>

        <Button
          style={{ marginBottom: "20px" }}
          onClick={() => {
            auth.signinRedirect({
              redirect_uri: window.location.href,
              extraQueryParams: {
                kc_action: "UPDATE_PASSWORD",
                login_hint: encodeURIComponent(auth.user.profile.email),
              },
            });
          }}
        >
          Change Password
        </Button>
      </div>
    </motion.div>
  );
};

export default UserProfileChangePasswordPage;
